<app-overlay [show]="isShowDialog()">
  <div class="popup" [style.width]="width()">
    <div class="popup-content" [style.text-align]="textAlign()">
      @if (imgSrc()) {
        <div class="popup-image">
          <img *ngIf="imgSrc()" [src]="imgSrc()" alt="{{ imgAlt() }}" />
        </div>
      }
      <div class="popup-header">
        @if (dialogTitle()) {
          <label class="title">{{ dialogTitle() }}</label>
        }
        @if (closeIcon()) {
          <span class="close">
            <img
              src="assets/images/kyc/kyc-view/close-kyc.svg"
              alt="close"
              (click)="closeDialog()" />
          </span>
        }
      </div>
      @if (dialogDescription()) {
        <label class="description">
          {{ dialogDescription() }}
        </label>
      }
      <ng-content select="[content]"></ng-content>
      <div class="actions">
        <ng-content select="[actions]"></ng-content>
      </div>
    </div>
  </div>
</app-overlay>
